import { useHistory } from "react-router-dom";
import NavigateToCreateBoardButton from "../atoms/NavigateToCreateBoardButton";
import STCreateBoardOnTopPage from "../../assets/styles/organisms/createBoardOnTopPage.module.scss";

const CreateBoardOnTopPage = () => {
  const history = useHistory();
  const handleClick = () => {
    history.push("/message-board/board/create");
  };
  return (
    <div className={STCreateBoardOnTopPage.wrapper}>
      <span className={STCreateBoardOnTopPage.title}>
        {"ぜひお気軽に投稿ください！\nお待ちしております♪"}
      </span>
      <NavigateToCreateBoardButton onClick={handleClick} />
    </div>
  );
};

export default CreateBoardOnTopPage;
